<script setup lang="ts">
    import { injectSiteSearchRootContext } from './site-search-root.vue'
    import { ref, watch } from 'vue'

    const context = injectSiteSearchRootContext()!

    function onInput(event: Event) {
        context.term.value = (event.currentTarget as HTMLInputElement)?.value
    }
    
    defineExpose({ el: context.input })
</script>
<template>
    <input
        role="combobox"
        :aria-controls="`site-search-results-${context.id}`"
        aria-autocomplete="list"
        :aria-expanded="context.expanded.value"
        :ref="(el) => context.input.value = el as HTMLInputElement"
        type="text"
        :value="context.term.value"
        @input="onInput"
    />
</template>